// Mock data for Demoboy landing page
export const siteData = {
  brand: {
    name: "demoboy",
    navCTA: "join waitlist",
  },
  hero: {
    headingLine1: "dont just send",
    headingHighlight1: "DEMOS",
    headingLine2: "let them try your",
    headingHighlight2: "PRODUCT",
    subtitle:
      "Demoboy turns your screen recording into a playable sandbox. No setup hassle. No backend access. One link.",
    ctaPrimary: "join waitlist",
    ctaSecondary: "see how it works",
  },
  whySection: {
    heading: "why we built\ndemoboy",
    headingHighlight: "?",
    description:
      "The average product demo converts under 2%. Not because the product is bad. Because nobody buys software they have never tried.",
    cards: [
      {
        number: "01",
        title: "you just\nwatch",
        body: "You see it on X. You think you will try it. You keep scrolling.",
      },
      {
        number: "02",
        title: "later never\ncomes",
        body: "You think you will try it when you have time. You save the link. You never open it again.",
      },
      {
        number: "03",
        title: "nothing\nclicks",
        body: "Even when you do watch the full demo, you still do not really get it. Because you never used it yourself.",
      },
    ],
  },
  betSection: {
    badge: "OUR BET",
    lines: [
      { text: "ads get clicks.", bold: false },
      { text: "launch videos get views.", bold: false },
    ],
    highlightLine: {
      prefix: "interactive demos get",
      highlight: "users.",
    },
    body: "But none of that makes you feel the product. Only trying it does. So we built demoboy. Because the best demos are not watched. They are felt.",
  },
  storySection: {
    label: "our story",
    heading: "how did we land on the idea for demoboy?",
    subtitle: "we wrote the whole thing down. go read it.",
    cta: "substack",
  },
  demosEvolved: {
    headingPrefix: "demos just",
    headingHighlight: "evolved",
    description:
      "You record your product once. Demoboy turns key moments into a safe interactive sandbox. Viewers pause, click around, and actually get it without touching your real backend.",
    steps: [
      {
        number: "01",
        titleHighlight: "record",
        titleRest: "your product",
        body: "Same as you already do. Screen or screen and cam. No new tools, no new habits.",
      },
      {
        number: "02",
        titleHighlight: "",
        titleRest: "we build the",
        titleSuffix: "sandbox",
        body: "Demoboy captures key moments, safe routes, and product state automatically from your recording.",
      },
      {
        number: "03",
        titleHighlight: "",
        titleRest: "our agent seeds",
        titleSuffix: "demo data",
        body: "Our agent fills the sandbox with realistic fake data. It looks like a live product without touching yours.",
      },
      {
        number: "04",
        titleHighlight: "share",
        titleRest: "one link",
        body: "Viewer watches, pauses, and tries the product. No setup. No backend. No rep needed in the room.",
      },
    ],
  },
  howItWorks: {
    steps: [
      {
        number: "01",
        title: "record",
        highlight: "your demo",
        description:
          "Same as you already do.\nScreen or screen and cam.\nNo new tools, no new habits.",
      },
      {
        number: "02",
        title: "we build",
        highlight: "the sandbox",
        description:
          "Demoboy captures key\nmoments, safe routes, and\nproduct state automatically\nfrom your recording.",
      },
      {
        number: "03",
        title: "populate",
        highlight: "with fake data",
        description:
          "Our agent fills the sandbox\nwith realistic fake data.\nIt looks like a live product\nwithout touching yours.",
      },
      {
        number: "04",
        title: "share",
        highlight: "one link",
        description:
          "Viewer watches, pauses, and\ntries the product. No setup.\nNo backend. No rep needed\nin the room.",
      },
    ],
  },
  forSection: {
    heading: "for anyone who needs to",
    headingHighlight: "show a product",
    headingEnd: "without the hassle.",
    subtitle:
      'No setup calls. No per-user onboarding. No "let me share my screen." Just one link that lets people feel the product.',
    roles: [
      {
        name: "founders",
        position: "top",
        description:
          "Stop driving every demo live. Record once, share forever. Let investors, early users, and accelerators try the product without touching production.",
      },
      {
        name: "growth & marketing",
        position: "bottom",
        description:
          "Replace your hero video with something people can actually click. Let visitors feel the product before they consider signing up.",
      },
      {
        name: "onboarding",
        position: "top",
        description:
          "Let new users feel the product before they create an account. Guided sandboxes replace walkthroughs nobody finishes.",
      },
      {
        name: "support",
        position: "bottom",
        description:
          "Replace screenshots with something users can click through. Fewer tickets. No production access needed.",
      },
      {
        name: "sales",
        position: "top",
        description:
          "Send the link before the meeting. Buyers explore on their own time. By the time they join, they already know if they want it.",
      },
    ],
  },
  analytics: {
    badge: "real analytics",
    heading: "per video, per sandbox.",
    cards: [
      {
        number: "one.",
        title: "sandbox heatmap",
        body: "Every click, every path, every moment your viewer explored. Not just video watch time.",
      },
      {
        number: "two.",
        title: "questions by timestamp",
        body: "See exactly which screen made people ask questions and what they typed tied to the exact moment.",
      },
      {
        number: "three.",
        title: "improve every demo",
        body: "Use real viewer behavior to find confusion, fix the flow, and make the next demo sharper.",
      },
    ],
  },
  cta: {
    heading: "let people try your product",
    subtitle: "no signup flows, no waiting, just one link",
    buttonText: "get early access",
    inputPlaceholder: "enter your email",
    extras: {
      title: "*something extra for early users",
      items: [
        "get 10 interactive demos",
        "10 lucky people get a limited demoboy metal card",
        "+lifetime access to PiP demos",
        "+ exclusive merch",
      ],
    },
  },
  footer: {
    terms: "Terms & Support",
    privacy: "Privacy Policy",
  },
};
